import ContactForm from '@/pages/about/components/ContactForm';
import { usePageMeta } from '@/hooks/usePageMeta';

const SERVICES = [
  {
    icon: 'ri-film-line',
    title: '剧情作品汇聚',
    desc: '收录多部完整男同剧情长片，覆盖青春、都市、年代等多元题材，呈现丰富的情感表达。',
  },
  {
    icon: 'ri-movie-2-line',
    title: '精选短片专区',
    desc: '汇聚篇幅精炼、表达细腻的短片作品，用更轻量的方式带来触动与共鸣。',
  },
  {
    icon: 'ri-stack-line',
    title: '专题深度策划',
    desc: '通过专题、访谈与盘点，梳理男同影像文化的发展脉络，帮助观众理解作品背后的故事。',
  },
  {
    icon: 'ri-compass-3-line',
    title: '便捷内容发现',
    desc: '提供分类浏览、多维筛选、关键词搜索与相关推荐，让每一次探索都更高效顺畅。',
  },
];

const CONTACTS = [
  { icon: 'ri-mail-line', label: '合作邮箱', value: 'hello@gayvideo-demo.com' },
  { icon: 'ri-time-line', label: '回复时间', value: '工作日 24 小时内回复' },
  { icon: 'ri-global-line', label: '服务范围', value: '线上内容平台，服务全球观众' },
];

export default function About() {
  usePageMeta({
    title: '关于我们 - 男同视频',
    description:
      '了解男同视频平台的定位、服务范围与联系方式。我们专注男同题材影像内容，聚合剧情、短片与专题，尊重多元、友善包容。',
    keywords: '男同视频,关于男同视频,男同影像平台,男同文化,内容合作',
  });

  return (
    <>
      <section className="relative h-[300px] w-full overflow-hidden md:h-[380px]">
        <img
          src="https://readdy.ai/api/search-image?query=cinematic%20warm%20lounge%20with%20soft%20golden%20light%20and%20film%20reels%2C%20cozy%20arthouse%20aesthetic%2C%20muted%20blue%20and%20amber%20tones%2C%20no%20people&width=1600&height=700&seq=gv-about-hero&orientation=landscape"
          alt="男同视频平台"
          title="关于男同视频"
          className="absolute inset-0 h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-950/90 via-primary-950/70 to-primary-950/40" />
        <div className="relative z-10 mx-auto flex h-full w-full max-w-7xl flex-col justify-center px-4 md:px-8">
          <span className="mb-3 flex w-fit items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-3 py-1 text-xs font-medium text-background-100 backdrop-blur-sm">
            <i className="ri-emotion-happy-line text-accent-300" />
            关于男同视频
          </span>
          <h1 className="max-w-2xl text-2xl font-extrabold leading-tight tracking-tight text-background-50 md:text-4xl">
            用影像记录真实，用故事连接彼此
          </h1>
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-background-200/90 md:text-base">
            男同视频是一个专注男同题材影像内容的文化平台，聚合剧情、短片与专题作品，
            让更多人能够便捷地发现、观看并理解属于自己的故事。
          </p>
        </div>
      </section>

      <section className="mx-auto w-full max-w-7xl px-4 py-10 md:px-8 md:py-16">
        <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-2 lg:gap-12">
          <div className="flex flex-col gap-4">
            <span className="flex w-fit items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              <i className="ri-quill-pen-line" />
              平台定位
            </span>
            <h2 className="text-xl font-bold tracking-tight text-foreground-950 md:text-3xl">
              一个专注男同题材影像的文化平台
            </h2>
            <p className="text-sm leading-relaxed text-foreground-600 md:text-base">
              我们希望为关注男同文化与影视作品的观众，提供一个内容多样、浏览舒适的影像空间。
              在这里，你既可以找到完整的剧情作品，也能发现篇幅精炼的短片，以及带有深度梳理的专题内容。
            </p>
            <p className="text-sm leading-relaxed text-foreground-600 md:text-base">
              平台坚持尊重多元、友善包容的原则，所有示例内容均为虚构创作，
              旨在呈现影像表达的丰富性与多样性，不涉及任何真实人物与侵权资料。
            </p>
            <div className="mt-2 flex flex-wrap gap-2">
              {['尊重多元', '友善包容', '内容合规', '用心推荐'].map((tag) => (
                <span
                  key={tag}
                  className="rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
          <div className="relative aspect-[4/3] w-full overflow-hidden rounded-lg bg-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=cinematic%20cozy%20screening%20room%20with%20warm%20projector%20light%2C%20soft%20seats%20and%20muted%20blue%20tones%2C%20arthouse%20film%20club%20aesthetic%2C%20no%20text&width=1000&height=750&seq=gv-about-position&orientation=landscape"
              alt="男同视频内容空间"
              title="男同视频平台定位"
              className="h-full w-full object-cover object-top"
            />
          </div>
        </div>
      </section>

      <section className="bg-background-100/70">
        <div className="mx-auto w-full max-w-7xl px-4 py-10 md:px-8 md:py-16">
          <div className="mb-6 flex flex-col gap-1">
            <h2 className="text-xl font-bold tracking-tight text-foreground-950 md:text-2xl">
              我们提供的内容与服务
            </h2>
            <p className="text-sm text-foreground-500">
              从内容聚合到便捷发现，帮助你更快找到感兴趣的作品。
            </p>
          </div>
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {SERVICES.map((service, index) => {
              const accents = ['accent', 'primary', 'secondary', 'primary'];
              const accent = accents[index % accents.length];
              return (
                <div
                  key={service.title}
                  className="flex flex-col gap-3 rounded-lg border border-background-200/80 bg-background-50 p-5"
                >
                  <span
                    className={`flex h-11 w-11 items-center justify-center rounded-lg ${
                      accent === 'accent'
                        ? 'bg-accent-100 text-accent-700'
                        : accent === 'primary'
                        ? 'bg-primary-100 text-primary-700'
                        : 'bg-secondary-100 text-secondary-800'
                    }`}
                  >
                    <i className={`${service.icon} text-xl`} />
                  </span>
                  <h3 className="text-base font-bold text-foreground-950">{service.title}</h3>
                  <p className="text-sm leading-relaxed text-foreground-500">{service.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="mx-auto w-full max-w-7xl px-4 py-10 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-12">
          <div className="flex flex-col gap-5">
            <h2 className="text-xl font-bold tracking-tight text-foreground-950 md:text-2xl">
              联系方式
            </h2>
            <p className="text-sm leading-relaxed text-foreground-600 md:text-base">
              若你有内容合作、内容反馈或版权相关的疑问，欢迎通过右侧表单与我们联系。
              我们会认真阅读每一条留言，并在工作日尽快回复。
            </p>
            <ul className="flex flex-col gap-3">
              {CONTACTS.map((item) => (
                <li
                  key={item.label}
                  className="flex items-center gap-3 rounded-lg border border-background-200/80 bg-background-50 p-4"
                >
                  <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                    <i className={`${item.icon} text-lg`} />
                  </span>
                  <span className="flex flex-col">
                    <span className="text-xs text-foreground-400">{item.label}</span>
                    <span className="text-sm font-medium text-foreground-800">{item.value}</span>
                  </span>
                </li>
              ))}
            </ul>
            <div className="flex items-start gap-3 rounded-lg border border-secondary-200 bg-secondary-50 p-4 text-sm text-secondary-900">
              <i className="ri-information-line mt-0.5 text-lg text-secondary-600" />
              <p>本表单为演示用途，用于收集合作与反馈信息，提交后由平台统一处理。</p>
            </div>
          </div>

          <div>
            <h2 className="mb-4 text-xl font-bold tracking-tight text-foreground-950 md:text-2xl">
              在线留言
            </h2>
            <ContactForm />
          </div>
        </div>
      </section>

      <section className="bg-background-100/70">
        <div className="mx-auto grid w-full max-w-7xl grid-cols-1 gap-6 px-4 py-10 md:grid-cols-2 md:px-8 md:py-14">
          <div className="flex flex-col gap-3 rounded-lg border border-background-200/80 bg-background-50 p-6">
            <h2 className="flex items-center gap-2 text-base font-bold text-foreground-950">
              <i className="ri-copyright-line text-primary-600" />
              版权声明
            </h2>
            <p className="text-sm leading-relaxed text-foreground-600">
              本站所有视频标题、封面与文字内容均为虚构示例，仅用于产品演示与交流学习，
              不涉及任何真实影片、真实演员或受版权保护的素材。如需引用或合作，请先通过留言表单与我们取得联系。
            </p>
          </div>
          <div className="flex flex-col gap-3 rounded-lg border border-background-200/80 bg-background-50 p-6">
            <h2 className="flex items-center gap-2 text-base font-bold text-foreground-950">
              <i className="ri-shield-check-line text-accent-600" />
              免责声明
            </h2>
            <p className="text-sm leading-relaxed text-foreground-600">
              本站内容面向成年观众，旨在展示男同题材影像的多样性。平台倡导尊重多元、友善包容的交流氛围，
              不鼓励任何形式的侵权、攻击或不当行为。若相关内容存在异议，请及时联系我们处理。
            </p>
          </div>
        </div>
      </section>
    </>
  );
}